import type { JSX } from "react";

import { Skeleton } from "@/components/ui/skeleton";

/** Mid-stream placeholder for ```user_questions / ```knowledge_options fences.
 * Matches a rough "question card" shape (title + chip row) so the user never
 * sees incomplete JSON while the turn is still generating. */
export function UserQuestionsStreamingSkeleton(): JSX.Element {
  return (
    <div className="my-2 space-y-3" aria-busy="true" aria-label="Cargando preguntas">
      <Skeleton className="h-4 w-3/5" />
      <div className="flex flex-wrap gap-2">
        <Skeleton className="h-8 w-16 rounded-md" />
        <Skeleton className="h-8 w-20 rounded-md" />
        <Skeleton className="h-8 w-16 rounded-md" />
        <Skeleton className="h-8 w-20 rounded-md" />
      </div>
    </div>
  );
}
